/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Pay_TooltipInputs */

const es_admin_billing_bills_list_pay_tooltip = /** @type {(inputs: Admin_Billing_Bills_List_Pay_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar factura`)
};

const en_admin_billing_bills_list_pay_tooltip = /** @type {(inputs: Admin_Billing_Bills_List_Pay_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay invoice`)
};

/**
* | output |
* | --- |
* | "Pay invoice" |
*
* @param {Admin_Billing_Bills_List_Pay_TooltipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_pay_tooltip = /** @type {((inputs?: Admin_Billing_Bills_List_Pay_TooltipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Pay_TooltipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_pay_tooltip(inputs)
	return en_admin_billing_bills_list_pay_tooltip(inputs)
});
export { admin_billing_bills_list_pay_tooltip as "admin.billing.bills_list.pay_tooltip" }